import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=77788e66&scoped=true"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"
import style0 from "./vertical.vue?vue&type=style&index=0&id=77788e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77788e66",
  null
  
)

export default component.exports